angular
  .module('sms.common.services')
  .service('phoneValidationService', phoneValidationService)

// Require 10 digit phone numbers for entry purposes
const PHONE_REGEX = /^(?:[() .-]*?\d[() .-]*?){10,}$/

function phoneValidationService() {
  const service = {}
  service.pattern = PHONE_REGEX
  return service
}
